import React, { useEffect } from 'react';

import Accordion from 'react-bootstrap/Accordion';
import Card from 'react-bootstrap/Card';

import meta from '../../config/meta';

import Header from '../layout/Header.jsx';
import PageHttp from '~/commons/components/PageHttp.jsx';
import Html from '~/commons/components/Html.jsx';
import AccordionHeader from '~/commons/components/AccordionHeader.jsx';
import useHttpStatus from '~/commons/hooks/useHttpStatus';

const PageQa = () => {
  const [res, req] = useHttpStatus();

  meta.set({ title: '常見問題' });

  useEffect(() => {
    req({ url: '/api/site/view-slots/app/qa' });
  }, []);

  return (
    <div>
      <Header
        bg={{
          left: '/assets/img/header-4-left.png',
          right: '/assets/img/header-4-right.png',
          color: '#dcf6fc',
        }}
      >
        <h3 className="text-center my-4">
          常見問題
        </h3>
      </Header>
      <div className="bg-paper">
        <PageHttp res={res} className="container py-5">
          {(view) => (
            <Accordion>
              {view.collapsibles.map((c, i) => (
                <Card key={c._id}>
                  <AccordionHeader eventKey={c._id}>
                    {i + 1}. {c.header}
                  </AccordionHeader>
                  <Accordion.Collapse eventKey={c._id}>
                    <Card.Body className="border-top">
                      <Html>{c.content}</Html>
                    </Card.Body>
                  </Accordion.Collapse>
                </Card>
              ))}
            </Accordion>
          )}
        </PageHttp>
      </div>
    </div>
  );
};

export default PageQa;
